export const error = state => state.error
export const isLoading = state => state.isLoading
export const retrieved = state => state.retrieved
export const updated = state => state.updated
export const violations = state => state.violations



// WEBPACK FOOTER //
// ./src/store/modules/contact_type/update/getters.js